import React, { useEffect, useState } from 'react';
import { useKeyPressNavigation } from '../../_utils';
import { createBaseSelect, SelectOption, SelectProps, SelectType } from '../base-select';
import { useSelect } from '../select-util';

export type SelectMenuProps = Omit<SelectProps, 'isMenuVisible' | 'type' | 'placeholder' | 'size'>;

export const Menu: React.FC<SelectMenuProps> = ({
  optionsGroups,
  selectedOptions,
  onChange,
  multiSelect,
  onKeyPressCB,
  menuRef,
  selectHeaderRef,
  ...restProps
}: SelectMenuProps) => {
  const type: SelectType = 'menu';
  const { visible, setSearchTerm, optionsResults } = useSelect(true, optionsGroups);

  // eslint-disable-next-line no-extra-boolean-cast
  const [currentSelectedOptions, setSelectedOptions] = useState<string[]>(selectedOptions || []);
  const flattenedOptions = optionsGroups.reduce(
    (acc: any, currentvalue: any) => [...acc, ...currentvalue.options],
    []
  );

  /** To get return the selected options on change if
   * multiSelect option is true
   */
  const getSelectedOptionsonChange = (filteredOptions: string[]) => {
    const optionsKeyValue = new Map<string, SelectOption>();
    flattenedOptions.forEach((option: SelectOption) => optionsKeyValue.set(option.id, option));
    const resultSelectedOptions: SelectOption[] = [];
    filteredOptions.forEach((key: string) =>
      resultSelectedOptions.push(optionsKeyValue.get(key) as SelectOption)
    );
    return resultSelectedOptions;
  };

  const onSelectCallback = (item: SelectOption) => {
    if (item) {
      const { id } = item;
      let filteredOptions;
      if (currentSelectedOptions.indexOf(id) >= 0) {
        filteredOptions = currentSelectedOptions.filter((option: any) => option !== id);
        setSelectedOptions([...filteredOptions]);
      } else {
        filteredOptions = [...currentSelectedOptions, id];
        setSelectedOptions(filteredOptions);
      }
      if (multiSelect && onChange) {
        onChange!(getSelectedOptionsonChange(filteredOptions!));
      }
      if (!multiSelect && onChange) {
        onChange!(item);
      }
      setSearchTerm('');
    }
  };

  const { cursor } = useKeyPressNavigation(document, flattenedOptions, onSelectCallback, visible);
  const menuProps = {
    type,
    isMenuVisible: true,
    optionsGroups: optionsResults,
    selectedOptions: currentSelectedOptions,
    multiSelect,
    onKeyPressCB,
    ...restProps,
  };
  useEffect(() => {
    if (cursor >= 0 && !!flattenedOptions[cursor]) {
      // this way all menu items will be accessed for screenreader even for those having id as number
      const ele = menuRef?.current?.querySelector(
        `[id="${flattenedOptions[cursor].id}"]`
      ) as HTMLOptionElement;

      ele?.focus();
    }
  }, [cursor, menuRef, flattenedOptions]);

  return createBaseSelect(menuProps, {
    setSearchTerm,
    onSelectCallback,
    dropDownHeader: null,
    dropDownHeaderRef: selectHeaderRef,
    optionHighlighted: flattenedOptions[cursor] === undefined ? null : flattenedOptions[cursor],
  });
};
